import reducer from './reducer';

export const { dismissUnsupportedBrowserBanner } = reducer.actions;
